import { DateTime } from "luxon";

import { IJob } from "../models/Job";

// A job counts as archived once a month has passed since the last thing happened on it -
// the most recent part removal, or its creation date if no parts were ever removed.
// Shared by the jobs calendar tabs and the bulk delete modal so the two can't disagree.
export default function isJobArchived(job: IJob): boolean {
  const removalDates = job.jobPartCategories
    ?.map((jpc) => jpc.partData?.removedOn)
    .filter((date): date is string => date !== null && date !== undefined)
    .map((date) => new Date(date)) ?? [];

  const oneMonthAgo = DateTime.now().minus({ months: 1 }).toJSDate();

  if (removalDates.length === 0) {
    return new Date(job.created) < oneMonthAgo;
  }

  const mostRecentRemoval = new Date(
    Math.max(...removalDates.map((d) => d.getTime()))
  );

  return mostRecentRemoval < oneMonthAgo;
}
